"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOrderNumberOfNights = void 0;
const dayjs = require("dayjs");
const getLatestOrderLineVersion_1 = require("./getLatestOrderLineVersion");
const getOrderNumberOfNights = (order) => {
    if (!order)
        return 0;
    const variant = order?.variants?.find((variant) => {
        return variant.id === order.default_variant_id;
    });
    if (!variant)
        return 0;
    if (!variant.order_lines)
        return 0;
    const hotel_lines = variant.order_lines.filter((orderLine) => {
        return orderLine.type === "HOTEL";
    });
    if (!hotel_lines)
        return 0;
    const hotel_dates = [];
    hotel_lines.forEach((hotel_line) => {
        if (!hotel_line.versions)
            return;
        const latest_version = (0, getLatestOrderLineVersion_1.getLatestOrderLineVersion)(hotel_line.versions);
        if (!latest_version)
            return;
        const config = latest_version.config;
        // add the dates to the hotel_dates array based on the check_in date and number of nights
        for (let i = 0; i < config.where_when_who?.number_of_nights; i++) {
            hotel_dates.push(dayjs(config.where_when_who?.check_in_date)
                .add(i, "day")
                .format("YYYY-MM-DD"));
        }
    });
    // remove duplicates
    const nights = [...new Set(hotel_dates)].length;
    return nights;
};
exports.getOrderNumberOfNights = getOrderNumberOfNights;
